import { motion } from 'framer-motion';

const galleryImages = [
  {
    url: '/assets/images/service-1.jpg',
    alt: 'Persönliche Sicherheit',
    category: 'Persönlicher Schutz'
  },
  {
    url: '/assets/images/service-2.jpg',
    alt: 'Geschützte Fahrten',
    category: 'Sicherere Fahrten'
  },
  {
    url: '/assets/images/service-3.jpg',
    alt: 'Modernstes Equipment',
    category: 'Top Ausrüstung'
  },
  {
    url: '/assets/images/service-4.jpg',
    alt: 'Repräsentativer Empfang',
    category: 'Objektschutz'
  },
  {
    url: '/assets/images/service-5.jpg',
    alt: 'Maximale Diskretion',
    category: 'Diskretion'
  },
];

export const ImageGallery = () => {
  return (
    <section className="py-8 bg-[#0B0F19]" data-testid="image-gallery">
      <div className="overflow-hidden">
        {/* Scrolling Gallery */}
        <motion.div
          className="flex gap-4"
          animate={{ x: [0, -1920] }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: "linear"
          }}
        >
          {[...galleryImages, ...galleryImages].map((image, index) => (
            <div
              key={index}
              className="relative flex-shrink-0 w-80 h-52 overflow-hidden rounded-sm group"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19] via-transparent to-transparent opacity-80" />
              <div className="absolute bottom-4 left-4">
                <span className="text-[#D4AF37] text-xs uppercase tracking-wider">{image.category}</span>
                <p className="text-[#F1F5F9] text-sm font-medium mt-1">{image.alt}</p>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
